@if (isOrderTracking && !isOctopusApp && showHeader) {
  <header class="tracking-header">
    <div class="tracking-header-inner">
      <img src="assets/images/play-octopus-logo.png" alt="Octopus" class="tracking-logo">
    </div>
  </header>
} @else if (!isOctopusApp && showHeader) {
  <header
    [ngClass]="{
        'bonus-header': !isSignup && isBonus,
        'login-header': !isLoggedin,
        'funnel-header':
            status !== 'Active Driver' &&
            (status !== 'former_driver' || !isSignup) &&
            status !== 'interested_mail_delivered' &&
            (status !== 'former_driver_mail_delivered' || !isSignup)
    }"
    id="header-section-main"
    >
    @if (
      isLoggedin &&
      (isAdmin ||
      status === 'Active Driver' ||
      (status === 'former_driver' && isSignup) ||
      status === 'interested_mail_delivered' ||
      (status === 'former_driver_mail_delivered' && isSignup))
      ) {
      <div
        class="main-container"
        >
        <span class="name-pic-wrap">
          @if (userSummary?.image_url) {
            <span
              class="profile-img"
                [ngStyle]="{
                    'background-image': 'url(' + userSummary?.image_url + ')'
                }"
            ></span>
          }
          @if (!userSummary?.image_url) {
            <span
              class="profile-img"
              style="background-image: url('assets/images/empty_profile.png')"
            ></span>
          }
          <span class="user-name"
            >{{ userSummary?.first_name }}
            {{ userSummary?.last_name | slice : 0 : 1 }}.</span
            >
          </span>
          <img
            class="logo"
            src="assets/images/play-octopus-logo.png"
            alt="Octopus Logo"
            />
          <span class="cursor-pointer"></span>
        </div>
      }
      @if (!isLoggedin) {
        <nav
          class="fixed-top navbar-expand-sm navbar-light octo-nav"
          >
          <div class="container">
            <img
              class="octo-logo"
              src="assets/images/play-octopus-logo.png"
              alt="Octopus Logo"
              id="header-logo-nav"
              />
            <button class="ham-menu" type="button" aria-label="Toggle navigation menu" (click)="toggleMenu()" id="header-button-hamburger-menu"></button>
            <button type="button" class="nav-link desktop-only" (click)="tosWarning()" id="header-link-login-desktop">Login</button>
            @if (showNav) {
              <button
                type="button"
                class="nav-link mobile-only"
                (click)="toggleMenu(); tosWarning()"
                id="header-link-login-mobile"
                >Login</button>
              }
            </div>
          </nav>
        }
        @if (
          isLoggedin &&
          !isAdmin &&
          status !== 'Active Driver' &&
          (status !== 'former_driver' || !isSignup) &&
          status !== 'interested_mail_delivered' &&
          (status !== 'former_driver_mail_delivered' || !isSignup)
          ) {
          <nav
            class="navbar navbar-expand-lg static-top"
            >
            <div class="container">
              <a class="navbar-brand" href="#" id="header-link-navbar-brand">
                <img
                  src="assets/images/octopus-logo-white.png"
                  src="assets/images/octopus-logo-white.png"
                  alt="octopus-logo"
                  class="logo logo-img"
                  id="header-logo-navbar"
                  />
              </a>
              <button
                class="navbar-toggler collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                >
                <span class="navbar-toggler-icon"></span
                  >{{ userSummary?.image_url }}
                </button>
                <div
                  class="navbar-collapse collapse"
                  id="navbarSupportedContent"
                  style=""
                  >
                  <ul class="navbar-nav ms-auto">
                    <li class="nav-item dropdown">
                      <a
                        class="dropdown-toggle"
                        href="#"
                        id="navbarDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        >@if (userSummary?.image_url) {
                        <img
                          [src]="userSummary?.image_url"
                          class="fix-width rounded-circle mr-1"
                          alt="Profile Image"
                          width="32"
                          height="32"
                          />
                      }
                      @if (
                        !userSummary?.image_url &&
                        userSummary?.status !==
                        'driver_info_complete' &&
                        userSummary?.status !== 'tos_complete'
                        ) {
                        <img
                          src="assets/images/empty_profile.png"
                          class="rounded-circle mr-1"
                          alt="Profile Image"
                          width="32"
                          height="32"
                          />
                      }
                      @if (
                        !userSummary?.image_url &&
                        (userSummary?.status ===
                        'driver_info_complete' ||
                        userSummary?.status === 'tos_complete')
                        ) {
                        <span
                          class="navbar-name"
                          >
                          {{ shortName }}
                        </span>
                      }
                    </a>
                    <ul class="dropdown-menu nav-link-item">
                      <li>
                        <p class="user-info">
                          <span
                            >{{ userSummary?.first_name }}
                            {{ userSummary?.last_name }}
                          </span>
                          <br />
                          <span>{{ userSummary?.email }}</span>
                        </p>
                      </li>
                      <li class="nav-item">
                        @if (
                          status === 'former_driver' ||
                          status ===
                          'former_driver_mail_delivered'
                          ) {
                          <a
                            class="nav-link"
                            [routerLink]="['/login']"
                            id="header-link-dashboard"
                            >Dashboard</a
                            >
                          }
                        </li>
                        <li class="nav-item">
                          <button
                            type="button"
                            class="nav-link"
                            (click)="gotoCurrentPage()"
                            id="header-link-my-account"
                            >My Account</button>
                          </li>
                          <li class="nav-item">
                            <button type="button" class="nav-link" (click)="logout()" id="header-link-logout"
                              >Logout</button>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </nav>
              }
            </header>
          }
